import React from "react";
import iconSynced from "../assets/icon_synced_file.svg";
import iconUpdate from "../assets/icon_update_file.svg";
import iconNew from "../assets/icon_new_file.svg";

const TabContainer = ({ tabs, activeTab, handleTabClick, handleCloseTab }) => {
  return (
    <div style={styles.tabContainer}>
      {tabs.map((tab) => {
        // Set icon based on tab state
        let icon;
        if (tab.state === "synced") {
          icon = iconSynced;
        } else if (tab.state === "update") {
          icon = iconUpdate;
        } else if (tab.state === "new") {
          icon = iconNew;
        }

        // Set background color based on tab state and active status
        let backgroundColor;
        if (tab.fileName === activeTab?.fileName) {
          // Active tab colors
          if (tab.state === "synced") {
            backgroundColor = "#ddd"; // Dark gray for active synced
          } else if (tab.state === "update") {
            backgroundColor = "#f1c40f"; // Dark yellow for active update
          } else if (tab.state === "new") {
            backgroundColor = "#a5d6a7"; // Dark green for active new
          }
        } else {
          // Non-active tab colors
          if (tab.state === "synced") {
            backgroundColor = "#f5f5f5"; // Light gray for non-active synced
          } else if (tab.state === "update") {
            backgroundColor = "#ffeb3b"; // Light yellow for non-active update
          } else if (tab.state === "new") {
            backgroundColor = "#c8e6c9"; // Light green for non-active new
          }
        }

        // Set font weight to bold if the tab is in "new" or "update" state
        const fontWeight = tab.state === "synced" ? "normal" : "bold";

        return (
          <div
            key={tab.fileName}
            style={{
              ...styles.tab,
              backgroundColor,
              fontWeight,
            }}
          >
            <img
              src={icon}
              alt={`${tab.state} icon`}
              style={{ ...styles.icon, filter: "brightness(0) saturate(100%)" }}
            />
            <span
              onClick={() => handleTabClick(tab.fileName)}
              style={styles.tabLabel}
            >
              {tab.fileName}
            </span>
            <span
              onClick={() => handleCloseTab(tab.fileName)}
              style={styles.closeIcon}
            >
              &times;
            </span>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  tabContainer: {
    display: "flex",
    justifyContent: "flex-start",
    maxWidth: "100%", // Limits the width of the tabs container
    overflowX: "auto",
  },
  tab: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    border: "1px solid #ccc",
    borderRadius: "5px 5px 0 0",
    marginRight: "5px",
    cursor: "pointer",
  },
  tabLabel: {
    paddingLeft: "5px",
    paddingRight: "10px",
  },
  closeIcon: {
    fontWeight: "bold",
    cursor: "pointer",
    marginLeft: "auto",
  },
  icon: {
    width: "16px",
    height: "16px",
    marginRight: "5px",
  },
};

export default TabContainer;
